import { useBracketContext } from "./Context";
import { RoundTitle } from "./components";
import Thorchain from "./logos/thorchain.svg";
import Avalanche from "./logos/avalanche.svg";
import Akash from "./logos/akash.svg";
import Default from "./logos/default.svg";
import Sui from "./logos/sui.svg";
import Mezo from "./logos/mezo.png";
import Polymarket from "./logos/polymarket.png";
import Base from "./logos/base.png";
import Stacks from "./logos/stacks.png";
import Solana from "./logos/sol.svg";
import Aptos from "./logos/aptos.png";
import Helium from "./logos/helium.png";
import Near from "./logos/near.png";
import Pyth from "./logos/pyth.svg";
import Doodles from "./logos/doodles.jpg";
import Bittensor from "./logos/bittensor.png";
import Sei from "./logos/sei.png";

import Aave from "./logos/aave-aave-logo.png";
import Hyperliquid from "./logos/Hyperliquid.png";
import Aerodome from "./logos/AERO.png";
import Lighter from "./logos/Lighter.png";
import Canton from "./logos/Canton.png";
import Ondo from "./logos/ondo-finance-ondo-logo.png";
import Stellar from "./logos/stellar-xlm-logo.png";
import Ton from "./logos/TON.png";
import Uniswap from "./logos/uniswap-uni-logo.png";
import Zcash from "./logos/zcash-zec-logo.png";
import Sire from "./logos/SIRE.jpg"
import Zora from "./logos/zora.png"
import Arbitrum from "./logos/arbitrum-arb-logo.png"

import cx from "classnames";

const classN =
  "hidden bracketTabs:flex bg-white py-2 top-[10px] sticky z-50 text-[#B4B4B4]";

// export const logos: Record<string, any> = {
//   thorchain: Thorchain,
//   avalanche: Avalanche,
//   akash: Akash,
//   algorland: Algorland,
//   arbitrum: Arbitrum,
//   filecoin: Filecoin,
//   optimism: Optimism,
//   solana: Solana,
//   flow: Flow,
//   cosmos: Cosmos,
//   livepeer: Livepeer,
//   sui: Sui,
//   eas: () => <img src={eas.src} alt="EAS" className="h-6" />,
//   pudgy: () => <img src={pudgy.src} alt="EAS" className="h-6" />,
//   lensphaver: () => <img src={phaver.src} alt="EAS" className="h-6" />,
//   polygon: Polygon,
//   default: Default,
//   meso: Default
// };

const Logo = ({ logo, project }: { logo: any; project: string }) => {
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={logo.src} alt={`${project} logo`} className="h-6" />;
};

export const logos: Record<string, any> = {
  default: Default,
  aave: () => <Logo logo={Aave} project="aave"/>,
  hyperliquid: () => <Logo logo={Hyperliquid} project="hyperliquid"/>,
  aerodrome: () => <Logo logo={Aerodome} project="aerodrome"/>,
  lighter: () => <Logo logo={Lighter} project="lighter"/>,
  canton: () => <Logo logo={Canton} project="canton"/>,
  ondo: () => <Logo logo={Ondo} project="ondo"/>,
  stellar: () => <Logo logo={Stellar} project="stellar"/>,
  ton: () => <Logo logo={Ton} project="ton"/>,
  uniswap: () => <Logo logo={Uniswap} project="uniswap"/>,
  zcash: () => <Logo logo={Zcash} project="zcash"/>,
  sire: () => <Logo logo={Sire} project="sire"/>,
  zora: () => <Logo logo={Zora} project="zora"/>,
  arbitrum: () => <Logo logo={Arbitrum} project="arbitrum"/>,  


  mezo: () => <Logo logo={Mezo} project="mezo" />,
  akash: Akash,
  thorchain: Thorchain,
  avalanche: Avalanche,
  polymarket: () => <Logo logo={Polymarket} project="polymarket" />,
  base: () => <Logo logo={Base} project="base" />,
  sui: Sui,
  stacks: () => <Logo logo={Stacks} project="stacks" />,
  solana: Solana,
  aptos: () => <Logo logo={Aptos} project="aptos" />,
  helium: () => <Logo logo={Helium} project="helium" />,
  near: () => <Logo logo={Near} project="near" />,
  pyth: Pyth,
  doodles: () => <Logo logo={Doodles} project="doodles" />,
  bittensor: () => <Logo logo={Bittensor} project="bittensor" />,
  sei: () => <Logo logo={Sei} project="sei" />
};

const isRoundActive = (startDay: string, endDay: string) => {
  // Convert the days to Date objects
  const currentDate = new Date();
  const startDayDate = new Date(startDay);
  const endDayDate = new Date(endDay);

  // Check if the day is between the start and end days
  return currentDate >= startDayDate && currentDate <= endDayDate;
};

export const useGetRounds = () => {
  const { matchups, teams: projects, matches: seeds } = useBracketContext();

  console.log("content", seeds);

  const getTeams = (gameId: string) => {
    return [matchups[gameId]?.home ?? null, matchups[gameId]?.away ?? null];
  };

  const round1 = {
    id: "round1",
    title: (
      <RoundTitle
        className={cx(classN, {
          "round-active": isRoundActive("2024-11-25", "2024-12-06")
        })}
        title="Round 1"
        date="Nov 25th - Dec 6th"
      />
    ),
    seeds: seeds.filter((seed: any) => seed.id.includes("r1"))
  };

  const rounds = [
    round1,
    {
      id: "round2",
      title: (
        <RoundTitle
          title="Round 2"
          className={cx(classN, {
            "round-active": isRoundActive("2024-12-09", "2024-12-16")
          })}
          date="Dec 9th - Dec 16th"
        />
      ),
      seeds: seeds.filter((seed: any) => seed.id.includes("r2"))
    },
    {
      id: "round3",
      title: (
        <RoundTitle
          className={cx(classN, {
            "round-active": isRoundActive("2024-12-16", "2024-12-20")
          })}
          title="Round 3"
          date="Dec 16th - Dec 20th"
        />
      ),
      seeds: seeds.filter((seed: any) => seed.id.includes("r3"))
    },
    {
      id: "final",
      title: (
        <RoundTitle
          className={cx(classN, {
            "round-active": isRoundActive("2025-01-07", "2025-01-30")
          })}
          title="Final"
          date="Jan 7th"
        />
      ),
      seeds: seeds.filter((seed: any) => seed.id.includes("final"))
    }
  ];

  return projects ? rounds : [];
};
